<template>
  <transition name="modal">
    <div class="winwin-modal-mask">
      <div class="winwin-modal-wrapper"
           @click="$emit('close')"
      >
        <div
          class="winwin-modal-container"
          @click.stop
          :style="{
            maxWidth
          }"
        >

          <div class="winwin-modal-header">
            <slot name="header">
            </slot>
          </div>

          <div class="winwin-modal-body">
            <slot name="body">
            </slot>
          </div>

          <div class="winwin-modal-footer">
            <slot name="footer">
            </slot>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'app-dialog',
  props: ['maxWidth']
}
</script>

<style scoped>
.winwin-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.winwin-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.winwin-modal-container {
  max-width: 885px;

  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.winwin-modal-header {
  margin: 20px 0;
}

.winwin-modal-body {
  margin: 20px 0;
  max-height: 70vh;
  overflow-x: auto;
}

.winwin-modal-footer {}
</style>
